import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const OldEntries = () => {

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  // const BASE_URL = "http://localhost:8080";
  const BASE_URL = "https://dbbackend.hmtbasic2ai.info";

  const fetchFiles = async () => {

    try {

      setLoading(true);

      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${BASE_URL}/api/file/upload/files`,
        // "http://localhost:8888/api/file/upload/files",
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setFiles(res.data.data);
      //console.log(res.data.data)

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

 const handleDelete = async (fileId) => {

    try {

        // ✅ Confirmation popup
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This file will be moved to trash.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
        });

        // ❌ If cancelled
        if (!result.isConfirmed) return;

        const token = localStorage.getItem("token");

        // 🚀 API call
        const res = await axios.put(
            `${BASE_URL}/api/file/upload/delete`,
            { file_id: fileId },
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        );

        // ✅ Success alert
        Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "File has been moved to trash.",
            timer: 1500,
            showConfirmButton: false
        });

        // console.log(res.data);
        window.location.reload(true);

        // 🔄 Optional: refresh list here
        // fetchFiles();

    } catch (err) {

        console.log(err);

        Swal.fire({
            icon: "error",
            title: "Delete Failed",
            text: err.response?.data?.message || "Something went wrong",
        });
    }
};

  return (
    <div className="container pt-4 bg-white" id="old_entries">

      <h1 className="mb-3" style={{fontSize:'30px'}}>Your Files</h1>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <div className="row">
            {files.length > 0 ?
            (
              files.map((file, index) => (
                <div className="col-md-4">
                  <div class="card">
                    <div className="card-title p-1">{file.stored_file_name.length > 30
                          ? file.stored_file_name.slice(0, 30) + "..."
                          : file.stored_file_name
                      }</div>
                    <div class="card-body p-1">
                      {file.file_type !== 'application/pdf' ? (
                        <img
                          src={`${BASE_URL}/files/${file.stored_file_name}`}
                          alt="preview"
                          className="img-fluid rounded w-100 shadow-sm"
                          style={{
                            height: "180px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (<div className="w-100 justify-content-center d-flex"><i class="bi bi-file-earmark-pdf-fill text-center" style={{fontSize:'120px'}}></i></div>)}
                        <hr className="mt-1"/>
                      <h5 class="card-title text-center">
                        {file.stat == 1 ?
                          <div className="text-success my-1"><i class="bi bi-graph-up-arrow"></i>&nbsp;&nbsp;Gain: {file.amount}</div> : <div className="text-danger my-1"><i class="bi bi-graph-down-arrow"></i>&nbsp;&nbsp;Spend: {file.amount}</div>}
                      </h5>
                      <p class="card-text" style={{height:'85px', fontSize:'12px'}}>{file.stat==-1?'Reason: ':'Source: '}{file.remarks.length > 147
                          ? file.remarks.slice(0, 147) + "..."
                          : file.remarks
                      }</p>
                      <p class="card-text" style={{fontSize:'12px'}}>Uploaded: {new Date(file.creation_date).toLocaleString()}</p>
                      <div className="card-footer">
                        <div className="d-flex w-100">
                          <a
                            href={`${BASE_URL}/files/${file.stored_file_name}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <button className="btn btn-sm btn-primary rounded-0">
                            <i class="bi bi-eye"></i>View
                            </button>
                          </a>
                          <button className="btn btn-sm btn-danger rounded-0 mx-1" onClick={()=>handleDelete(file.file_id)}><i class="bi bi-trash3"></i>Delete</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))) : <div className="alert alert-danger" role="alert">No files uploaded yet.</div>}
          </div>
        </div>
      )}

    </div>
  );
};

export default OldEntries;